module.exports = __webpack_public_path__ + "media/images/logos/windeurope-summit2018-90c2592124acb2dc0f267d826af8b4ea.svg";